"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateMyProfileEndpoint = void 0;
const endpoint_1 = require("../../general/endpoint");
class UpdateMyProfileEndpoint extends endpoint_1.BasePatchEndpoint {
    constructor(_a) {
        var { profileId } = _a, request = __rest(_a, ["profileId"]);
        super();
        this.getBody = () => {
            return this.request;
        };
        this.profileId = profileId;
        this.request = request;
    }
    getUrl() {
        return `/v2/me/profiles/${this.profileId}`;
    }
}
exports.UpdateMyProfileEndpoint = UpdateMyProfileEndpoint;
